import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '@features/auth/services/auth-state.service';

/**
 * Protects authenticated areas (e.g. the `dashboard` route): lets authenticated
 * users through and redirects everyone else to the `auth` feature.
 */
export const authGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  return authState.isAuthenticated() ? true : router.createUrlTree(['/auth']);
};
